import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';

@Component({
    selector: 'unassign-active-modal',
    templateUrl: './unassign-active-modal.html'
})

export class UnassignActiveWindow extends BaseComponent {
    constructor(public dialogRef: MatDialogRef<UnassignActiveWindow>) {
        super();
    }

    ngOnInit() {
    }

    public accept() {
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close();
    }
}
